const getXlsx = async () => {
  const { default: XLSX } = await import('xlsx');
  return XLSX;
};

export const exportCSV = async (name: string, head: string[][], body: any[][]) => {
  const XLSX = await getXlsx();
  const ws = XLSX.utils.aoa_to_sheet([
    ...head,
    ...body,
  ]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, ws, name);
  XLSX.writeFile(workbook, `${name}.xlsx`);
};

export const exportCSVBatch = async (name: string, batch: { name: string, head: string[][], body: any[][] }[]) => {
  const XLSX = await getXlsx();
  const workbook = XLSX.utils.book_new();
  batch.forEach(((sheet) => {
    const ws = XLSX.utils.aoa_to_sheet([
      ...sheet.head,
      ...sheet.body,
    ]);
    XLSX.utils.book_append_sheet(workbook, ws, sheet.name);
  }));
  XLSX.writeFile(workbook, `${name}.xlsx`);
};

/**
 * 一键导出ant table
 * @param columns
 * @param dataSource
 * @param fileName
 */
export const exportAntdTable = async (columns: any, dataSource: any, fileName: string) => {
  const XLSX = await getXlsx();
  // 构造表头
  const xlsxHeader = [columns.map((column: any) => column.titleString || column.title)];

  // 列定义打平
  const columnRecord: Record<string, any> = {};
  columns.forEach((column: any) => {
    columnRecord[column.dataIndex] = column;
  });

  // 构造数据
  const xlsxBody: any = [];
  dataSource.forEach((item: any, index: number) => {
    const cellValues: any = [];

    columns.forEach((column: any) => {
      const sourceValue = item[column.dataIndex];
      const displayCellValue = column.render ? column.render('', item, index) : sourceValue;
      cellValues.push(displayCellValue);
    });

    xlsxBody.push(cellValues);
  });

  // 导出
  const ws = XLSX.utils.aoa_to_sheet([
    ...xlsxHeader,
    ...xlsxBody,
  ]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, ws, fileName);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
